module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-05-0a2ceb27df93c265d119ad0449ebe66d.svg";